module.exports = __webpack_public_path__ + "img/result-window.0f32f411.svg";